;
define("display_shipping_type.tpl", function(){});

